var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { palette } from '@/theme/palette';
import { CirclesSelect } from 'hx-ui';
export function CircleSelect(props) {
    return (_jsx(CirclesSelect, __assign({ labelProps: {
            className: 'font-[montserrat]',
        }, itemStyles: {
            boxShadow: '0 0 4px 2px #00000022',
            border: '3px solid var(--circle-select-color)',
            svg: {
                stroke: 'var(--circle-select-color)',
                strokeWidth: 1.5,
            },
            '&[data-state="checked"]': {
                svg: { stroke: 'white' },
                border: '3px solid white',
            },
            '&:focus': {},
            '&:hover': {
                backgroundColor: palette.secondary.main,
                svg: { stroke: 'white' },
                opacity: 0.8,
            },
        }, routeClass: "grid-cols-2" }, props)));
}
